import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { pathTo } from '../../../App/routes';
import { timeToClock, ratioToPercentPlus } from '../../../lib/format';

const BoxscorePlayerRow = ({ boxscore, player, total = false }) => {
  return (
    <tr
      key={player ? player.id : 'team'}
      className={
        total ? 's-game-explorer__boxscore__side__table__total-row footer' : ''
      }
    >
      {total ? (
        <td
          colSpan="2"
          className="s-game-explorer__boxscore__side__table__total-label boxscore-table-text"
        >
          TOTALS
        </td>
      ) : (
        player && (
          <td className="s-game-explorer__boxscore__side__table__player boxscore-table-text">
            <span className="s-game-explorer__boxscore__side__table__player--jersey">
              {player.jersey !== 1000 ? `#${player.jersey}` : ''}
            </span>
            <span className="s-game-explorer__boxscore__side__table__player--name">
              <Link
                className="s-game-explorer__boxscore__side__table__player--link"
                to={pathTo('player', player.id)}
                disabled={!player.id}
              >
                {player.is_team ? 'TEAM' : player.name}
              </Link>
            </span>
          </td>
        )
      )}
      {!total && !player.is_team && <td>{timeToClock(boxscore.minutes)}</td>}
      {!total && player.is_team && <td></td>}
      <td>
        {boxscore.fgm}/{boxscore.fga}{' '}
        {total && (
          <div>{ratioToPercentPlus(boxscore.fgm / boxscore.fga, 1)}</div>
        )}
      </td>
      <td>
        {boxscore.fgm3}/{boxscore.fga3}{' '}
        {total && (
          <div>{ratioToPercentPlus(boxscore.fgm3 / boxscore.fga3, 1)}</div>
        )}
      </td>
      <td>
        {boxscore.ft}/{boxscore.fta}{' '}
        {total && (
          <div>{ratioToPercentPlus(boxscore.ft / boxscore.fta, 1)}</div>
        )}
      </td>
      <td>{boxscore.rebso}</td>
      <td>{boxscore.rebsd}</td>
      <td>{boxscore.rebs}</td>
      <td>{boxscore.ast}</td>
      <td>{boxscore.stl}</td>
      <td>{boxscore.blk}</td>
      <td>{boxscore.to}</td>
      <td>{boxscore.fouls}</td>
      <td>{boxscore.plus_minus}</td>
      <td>{boxscore.pts}</td>
    </tr>
  );
};

BoxscorePlayerRow.propTypes = {
  playerBoxscore: PropTypes.object,
};

export default BoxscorePlayerRow;
